import { memo } from 'react';
import { formatSource, type SectorGroupItem } from './sectorIntel.types';

interface Props {
  items: SectorGroupItem[];
  isLoading?: boolean;
  onRowClick: (item: SectorGroupItem) => void;
}

export function SectorGroupsTable({ items, isLoading, onRowClick }: Props): JSX.Element {
  return (
    <div className="pca-table-wrap">
      <div style={{ maxHeight: '65vh', overflowY: 'auto' }}>
        <table className="pca-table" data-testid="sector-groups-table">
          <thead>
            <tr>
              <th style={{ width: 110 }}>섹터 유형</th>
              <th>섹터명</th>
              <th style={{ width: 180 }}>Canonical ID</th>
              <th style={{ width: 160 }}>최종 섹터</th>
              <th style={{ width: 140 }}>소스</th>
              <th style={{ width: 90 }}>종목수</th>
              <th style={{ width: 110 }}>편입일</th>
              <th style={{ width: 110 }}>제외일</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr>
                <td colSpan={8} className="pca-empty">
                  불러오는 중…
                </td>
              </tr>
            )}
            {!isLoading && items.length === 0 && (
              <tr>
                <td colSpan={8} className="pca-empty">
                  조건에 맞는 섹터가 없습니다.
                </td>
              </tr>
            )}
            {items.map((it) => (
              <SectorGroupRow
                key={`${it.sectorType}-${it.sectorName}-${it.source}-${it.validFrom}`}
                item={it}
                onClick={onRowClick}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const SectorGroupRow = memo(function SectorGroupRow({
  item,
  onClick,
}: {
  item: SectorGroupItem;
  onClick: (item: SectorGroupItem) => void;
}): JSX.Element {
  return (
    <tr
      className="si-group-row"
      onClick={() => onClick(item)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(item);
        }
      }}
    >
      <td>
        <span className={`pca-status-badge si-badge--${item.sectorType.toLowerCase()}`}>
          {item.sectorType}
        </span>
      </td>
      <td>{item.sectorName}</td>
      <td>
        {item.canonicalSectorId ? (
          <code>{item.canonicalSectorId}</code>
        ) : (
          <span className="pca-muted">—</span>
        )}
      </td>
      <td>
        {item.canonicalDisplayName ?? <span className="pca-muted">—</span>}
      </td>
      <td>{formatSource(item.source)}</td>
      <td>{item.stockCount.toLocaleString('ko-KR')}</td>
      <td>{item.validFrom}</td>
      <td>{item.validTo ?? <span className="pca-muted">진행중</span>}</td>
    </tr>
  );
});
